<template>
  <div class="hp-aicc">
    <!--main banner-->
    <section class="main-banner-hp">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-content-wrapper">
              <h3>HelpNow AI Contact Center</h3>
              <h2>클라우드 기반 <br class="pcblock"/>
              AI 컨택센터를 위한 <br class="mblock"/>
              단 하나의 선택</h2>
              <p>
                컨택센터에 AI, Cloud 기술을 접목하여 차세대 컨택센터로의 전환을 돕습니다. <br class="pcblock"/>
                상담원의 역량은 증진되고 고객 서비스 품질은 향상됩니다.
              </p>
              <a href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동" class="btn_white">문의하기</a>
            </div>
          </div>
          <div class="col-lg-6 align-self-end">
            <div class="mb-image txt_center">
              <img src="@/assets/image/img_helpnow_aicc.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--Modal-->
    <div class="modal fade hp-aicc-modal" id="hpModalCenter"
      :class="{
        'block' : onViewBox,
        'show' : onViewBox
      }">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close close" @click="onStartCall()"></button>
          </div>
          <template v-if="!onTelBox">
            <div class="modal-body">
              <!--body-->
              <div class="wrap-modal-title">
                <h5 class="modal-title">AI 에이전트 체험하기</h5>
                <p class="modal-txt-experience">
                  아래 정보를 입력하고 AI 에이전트가 수행하는 <br class="pcblock"/>
                  인바운드 통화 및 아웃바운드 통화를 체험해보세요.
                </p>
              </div>
              <div class="wrap_experience">
                <div class="col-md-12 box_experience">
                  <!-- Name input-->
                  <div class="form-group01">
                    <label class="control-label col-md-3" for="pop_name">이름</label>
                    <div class="col-md-9">
                      <input id="pop_name" name="pop_name" type="text" class="form-control">
                      <p class="invalid-message">
                        이름을 입력해주세요.
                      </p>
                    </div>
                  </div>
                  <div class="form-group01">
                    <label class="control-label col-md-3" for="pop_phone">휴대폰 번호</label>
                    <div class="col-md-9">
                      <input id="pop_phone" name="pop_phone" type="text" class="form-control" invalid="true">
                      <p class="invalid-message">
                        휴대폰 번호를 입력해주세요.
                      </p>
                    </div>
                  </div>
                  <div class="form-group01">
                    <label class="control-label col-md-3" for="pop_email">이메일</label>
                    <div class="col-md-9">
                      <input id="pop_email" name="pop_email" type="email" class="form-control" invalid="true">
                      <p class="invalid-message">
                        이메일을 입력해주세요.
                      </p>
                    </div>
                  </div>
                  <div class="form-group01">
                    <label class="control-label col-md-3" for="pop_company">기업명</label>
                    <div class="col-md-9">
                      <input id="pop_company" name="pop_company" type="text" class="form-control" invalid="true">
                      <p class="invalid-message">
                        기업명을 입력해주세요.
                      </p>
                    </div>
                  </div>
                  <div class="box_contact">
                    <div class="col-md-12">
                      <div class="form-group01">
                        <p class="description">
                          개인정보 수집 및 이용 동의
                        </p>
                        <textarea class="form-control" id="pop_ch01" name="pop_ch01" rows="3" readonly>베스핀글로벌 주식회사는 HelpNow AI AI Contact Center 체험 서비스 제공을 위해 다음과 같이 개인정보를 수집 및 이용합니다. 개인정보의 수집 및 이용에 대한 동의를 거부하실 수 있으나, 이 경우 체험 서비스 제공이 어려울 수 있습니다. 1. 수집하는 개인정보 항목 : 이름, 휴대폰번호, 이메일주소, 기업명, 음성정보 2. 개인정보의 수집 및 이용 목적 : AI 에이전트 서비스 체험 만족도 조사, 서비스 개선 및 성능향상, 광고성 정보 제공 등 프로모션 3. 개인정보의 이용 및 보유기간 : 서비스 체험 내역 분석 및 통계, 사용자 연락을 위해 1년간 보관 후 파기 간 보관됩니다. - 본 동의를 거부할 수 있으나, 미동의 시 문의 접수가 불가능합니다.</textarea>
                        <p class="label_description" for="pop_ch01">
                          <label><input type="checkbox" name="agree" value="1"> 개인정보 수집 및 이용에 동의합니다. (필수)</label>
                        </p>
                        <p class="label_description" for="pop_ch01">
                          <label><input type="checkbox" name="agree" checked="checked" value="2"> 마케팅 정보 수신에 동의합니다. (선택)</label>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--body-->
            </div>
            <div class="modal-footer">
              <button type="button" class="btn_purple" @click="onTelTest()" id="btn_start">체험 시작</button>
            </div>
          </template>

          <div class="wrap_tel" v-if="onTelBox">
            <div class="wrap-modal-title-next">
              <h5 class="modal-title-tel">AI 에이전트 전화상담 체험하기</h5>
              <p class="modal-txt-tel">
                아래 번호로 전화하여 데모 봇과 통화해보세요.
              </p>
            </div>
            <div class="wrap_tel_box col-md-12">
              <h3 class="tit_tel_box">인바운드 콜 – 보일러 A/S 신청 접수</h3>
              <p class="txt_tel_box">
                아래 번호로 전화하여 AI 상담원을 통한 보일러 A/S 신청 접수를 체험해보세요.
              </p>
              <p class="num_tel_box">
                000 - 000 - 0000
              </p>
            </div>
            <div class="wrap_tel_box col-md-12 mr-b30">
              <h3 class="tit_tel_box">아웃바운드 콜 - 보험 상품 가입 해피콜</h3>
              <p class="txt_tel_box">
                아래 번호로 전화하여 AI 상담원을 통한 가입 보험 상품에 대한 해피콜을 체험해보세요.
              </p>
              <p class="num_tel_box">
                000 - 000 - 0000
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- <section class="row-hp-pd hp-aicc-info">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="tit_hp">AI 상담원 체험하기</h1>
          </div>
        </div>
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-6 m_txt_center">
              <img src="@/assets/image/img_aicc_01.png" class="img_characteristic"/>
            </div>
            <div class="col-md-6 m_txt_center">
              <h3 class="subtit_hp mr-b40 subtit_black">상담사를 대신하여 고객과 음성 대화할 수 있는 <br class="pcblock"/>AI 음성봇을 지금 바로 체험해보세요.</h3>
              <a class="btn_purple" title="AI 상담원 체험하기" @click="onStartCall()">AI 상담원 체험하기</a>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="row-hp-pd120 page-service">
      <div class="container">
        <div class="row">
        <div class="col-md-12">
          <h1 class="tit_hp">AI로 진화하는 디지털 컨택센터</h1>
          <h3 class="subtit_hp">전통적인 콜센터 시스템에 음성인식, 음성합성, Agent Assist 등의 AI 기술과 클라우드 기술을 접목하여<br/>차세대 컨택센터로 도약할 수 있도록 지원합니다.</h3>
        </div>
        </div>
        <div class="row box_row pd-t0 align-items-center pd_b50">
        <div class="col-md-6 box_left box_txt">
          <h5 class="box_tit">대규모 개발없이 신속하게 AI 컨택센터로 전환</h5>
          <p class="box_subtxt">
            별도의 개발이 필요 없는 대화형 AI 플랫폼을 기반으로 기존 콜센터 시스템을 단기간에 현대화 할 수 있습니다.
          </p>
          <ul class="ul_box">
            <li>챗봇, 보이스봇, Agent Assist, Live Chat 등 AI 컨택센터를 위한 포괄적인 기능 지원</li>
            <li>SIP Proxy/Media 서버를 제공하여 간단한 설정만으로 콜시스템과 연계한 콜봇 구현</li>
            <li>전화 외에도 메신저, AI 스피커 등 고객이 원하는 다양한 채널로 고객 서비스 확대</li>
          </ul>
        </div>
        <div class="col-md-6 box_right box_img">
          <img src="@/assets/image/img_aicc_02.jpg"/>
        </div>
        </div>
        <div class="row box_row featurette align-items-center pd50">
        <div class="col-md-6 box_right box_txt order-md-2">
          <h5 class="box_tit">1,000명의 상담도 동시에 유연하게 대응</h5>
          <p class="box_subtxt">
            SIP를 통해 PBX에 연결되는 클라우드 시스템을 사용하므로 인프라에 대한 투자 없이 갑작스럽게 증가한 대량의 문의도 한번에 처리 할 수 있습니다.
          </p>
          <ul class="ul_box">
            <li>인바운드 상담 문의가 갑자기 증가하여도 대기 시간 없이 고객 셀프 서비스 가능</li>
            <li>대규모 아웃바운드콜 진행 시 몇 분만에 1,000명의 고객에게 도달 가능</li>
          </ul>
        </div>
        <div class="col-md-6 box_left box_img order-md-1">
          <img src="@/assets/image/img_aicc_03.jpg"/>
        </div>
        </div>
        <div class="row box_row align-items-center">
        <div class="col-md-6 box_left box_txt">
          <h5 class="box_tit">Agent Assist를 통한 상담원 역량 강화</h5>
          <p class="box_subtxt">
            AI/ML 기술을 활용하여 상담원이 고객 문의에 더 빠르게 대응하고 더 많은 상담을 처리 할 수 있으며, 초보 상담원도 일관성 있는 고품질 응답을 제공할 수 있습니다.
          </p>
          <ul class="ul_box">
            <li>문장 분류/유사도/딥러닝 기법을 통해 고객이 질문한 내용을 실시간으로 전달 받고, 관련 문서 검색 또는 예전 대화 내용을 상담원에게 제공</li>
            <li>상담이 진행되는 동안 발생하는 상담원의 발화와 사용자의 응답을 자동으로 수집</li>
          </ul>
        </div>
        <div class="col-md-6 box_right box_img">
          <img src="@/assets/image/img_aicc_04.png"/>
        </div>
        </div>
        <div class="row box_row align-items-center">
        <div class="col-md-6 box_right box_txt order-md-2">
          <h5 class="box_tit">AI 에이전트와 상담원 간 자연스러운 상담 전환</h5>
          <p class="box_subtxt">
            AI 에이전트와의 상담 진행 도중 상담원 연결이 필요한 경우 중단 없이 자연스러운 상담 전환이 가능합니다.
          </p>
          <ul class="ul_box">
            <li>챗봇과 상담하는 도중 상담원 연결이 필요하면 실시간 상담 채팅 모드로 전환</li>
            <li>음성봇과 통화하는 중에 상담원 연결이 필요한 경우 즉시 상담원 연결 수행</li>
          </ul>
        </div>
        <div class="col-md-6 box_left box_img order-md-1">
          <img src="@/assets/image/img_aicc_05.png"/>
        </div>
        </div>
        <div class="row box_row border0 align-items-center">
        <div class="col-md-6 box_left box_txt">
          <h5 class="box_tit">클라우드 기반의 AICC 구축부터 운영까지 지원</h5>
          <p class="box_subtxt">
            클라우드 전문 기업으로 레거시 콜센터를 차세대 클라우드 컨택센터로 전환하기 위해 필요한 모든 서비스를 통합적으로 제공합니다.
          </p>
          <ul class="ul_box">
            <li>클라우드 인프라 구축 및 운영 서비스 제공</li>
            <li>CSP를 비롯한 다양한 기업의 AI/ML 서비스 연동</li>
            <li>IPCC와 AI 연계를 위한 구축형 AICC 미들웨어 제공</li>
          </ul>
        </div>
        <div class="col-md-6 box_right box_img">
          <img src="@/assets/image/img_aicc_06.png"/>
        </div>
        </div>
        <!-- <div class="container">
          <div class="row">
            <div class="col-md-12 txt_center mr-t30">
              <a class="btn_purple" data-bs-toggle="modal" data-bs-target="#hpModalCenter" title="" @click="onStartCall()">HelpNow AI Contact Center 상담원 체험하기</a>
            </div>
          </div>
        </div> -->
        
      </div>
    </section>

    <section class="row-hp-pd hp-aicc-service">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="tit_hp">서비스 구성도</h1>
            <h3 class="subtit_hp">AI 기술과 PBX, CTI 등 콜센터 정보시스템을 결합하여 인공지능 기반의 상담봇이 상담사를 대신하여 <br class="pcblock"/>다양하고 복잡한 고객상담 업무를 처리합니다. 상담사는 상담지원, 상담분석 등을 통해 전문 상담에 집중할 수 있습니다.</h3>
          </div>
        </div>
        <div class="container m_pd0">
          <div class="row m_pd0">
            <div class="col-md-12 txt_center m_pd0">
              <img src="@/assets/image/img_aicc_07.jpg" class="img-aicc-service mr-b50"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="row-hp-pd120 hp-aicc-field">
      <div class="container">
        <div class="row mr-b120">
          <div class="col-md-12">
            <h1 class="tit_hp">차세대 컨택센터로 고객 만족도 향상 및 업무 효율을 높이세요</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="box-field">
              <h3 class="row2_box_tit">인바운드콜 자동화</h3>
              <h5 class="row2_box_purple">대기 시간이 없고 24시간 상담 가능한 AI 상담원</h5>
              <p>
                특정 기간, 특정 요일, 특정 시간에 상담 문의가 집중돼도 <br class="pcblock"/>
                고객은 대기 시간 없이 AI 상담원과 대화하여 <br class="pcblock"/>
                문제를 해결할 수 있습니다.
              </p>
              <ul class="ul_box">
                <li>아파트 분양에 따른 분양 일정, 분양 접수 등 안내</li>
                <li>보일러와 같이 특정 시즌에 집중되는 A/S 문의 대응</li>
                <li>마케팅, 캠페인 등 홍보 행사 이후 일시적 폭주 문의 대응</li>
                <li>식당, 헤어샵과 같이 오프라인 매장에 대한 영업점 위치, 영업 시간, 주차 안내 등 고객 질문 응대 및 예약 진행</li>
                <li>호텔, 리조트, 골프 클럽 등 숙박/레저 시설에 대한 안내 및 고객 문의 대응, 예약 가능 일자 확인 및 예약 진행</li>
              </ul>
            </div>
          </div>
          <div class="col-md-6">
            <div class="box-field">
              <h3 class="row2_box_tit">아웃바운드콜 자동화</h3>
              <h5 class="row2_box_purple">고객과 양방향 소통이 가능한 아웃바운드 통화</h5>
              <p>
                보험 가입 후 해피콜이나 여행 상품 예약 확인 등 <br class="pcblock"/>
                반복적인 아웃바운드 콜 업무도 몇 분만에 수많은 고객과 <br class="pcblock"/>
                통화하여 처리할 수 있습니다.
              </p>
              <ul class="ul_box">
                <li>보험, 투자 상품 등에 대한 불완전판매 모니터링</li>
                <li>보험사 사고 처리 안내</li>
                <li>여행 상품 예약 해피콜</li>
                <li>고객 만족도 조사</li>
                <li>선거 지지율 조사</li>
                <li>방송사 청취율 조사</li>
                <li>병원, 식당, 헤어샵 등 방문 예약 유지 여부 및 변경/취소 처리 </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="row-hp-btn-bg pd_b50">
      <div class="container">
        <div class="row">
          <div class="col-md-12 txt_center">
            <h1>With HelpNow AI AICC</h1>
            <h3>HelpNow AI와 함께 차세대 컨택센터로 변화해 보세요.</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 txt_center">
            <a href="https://www.bespinglobal.com/contact/" target="_blank" title="문의하기 이동" class="btn_white">문의하기</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery"

export default {
  name: 'Aicc',
  components: {
    
  },
  data() {
    return {
      onViewBox: false, 
      onTelBox: false, 
    }
  },
  computed: {},
  watch: {},
  created(){},
  mounted(){},
  beforeDestroy() {},
  methods: {
    onChangeRoute(routeName, event) {
      event.preventDefault();
      this.$router.push({name: routeName})

      window.scrollTo(0, 0); 
    }, 

    onStartCall() {
      this.onViewBox = !this.onViewBox; 
      this.onTelBox = false; 
      this.onViewBox ? document.body.classList.add('modal-open') : document.body.classList.remove('modal-open');
    }, 

    onTelTest() {
      this.onTelBox = true; 
    }, 
  }
}
</script>

<style lang="scss" scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/Aicc.vue